import React, { useState } from 'react';
import Carousel from './Carousel.js';
import { motion } from "framer-motion";

function Page2Mobile() {

    const [isHovered, setIsHovered] = useState(false);
    
    const handleHoverChange = (isHovered) => {
        setIsHovered(isHovered);
    };


    return (
        <div className="page2">
            <div className='section-about'>
                <h1>About Me</h1>
                <motion.h2
                    initial={{clipPath: "inset(0% 100% 0% 0%)" }}
                    whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
                    viewport={{ once: true }}>
                    Craft solutions</motion.h2>
                <motion.h2
                    initial={{ clipPath: "inset(0% 100% 0% 0%)" }}
                    whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
                    viewport={{ once: true }}>
                    Refine Ideas</motion.h2>
                <motion.h2
                    initial={{ clipPath: "inset(0% 100% 0% 0%)" }}
                    whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.2 }}
                    viewport={{ once: true }}>
                    To <span className="line-break">Make</span></motion.h2>
                <motion.div 
                initial={{width: "0"}}
                whileInView={{width: "100vw"}}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
                className='purple-background'>
                    <motion.h2
                    initial={{opacity: 0, y: 50}}
                    whileInView={{opacity: 1, y: 0}}
                    transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
                    viewport={{ once: true }}>
                        Great Work
                    </motion.h2>
                </motion.div>
                <div className='background-words'>
                    <p>
                        Adaptable
                    </p>
                    <p>
                        Adaptable
                    </p>
                    <p>
                        Adaptable
                    </p>
                    <p>
                        Adaptable
                    </p>
                </div>
                <div className='background-words'>
                    <p>
                    Curious
                    </p>
                    <p>
                    Curious
                    </p>
                    <p>
                    Curious
                    </p>
                    <p>
                    Curious
                    </p>
                </div>
                <div className='background-words'>
                    <p>
                    Collaborative
                    </p>
                    <p>
                    Collaborative
                    </p>
                    <p>
                    Collaborative
                    </p>
                    <p>
                    Collaborative
                    </p>
                </div>
                <div className='background-words'>
                    <p>
                    Curious
                    </p>
                    <p>
                    Curious
                    </p>
                    <p>
                    Curious
                    </p>
                    <p>
                    Curious
                    </p>
                </div>
                <div className='background-words'>
                    <p>
                    Collaborative
                    </p>
                    <p>
                    Collaborative
                    </p>
                    <p>
                    Collaborative
                    </p>
                    <p>
                    Collaborative
                    </p>
                </div>
                <div className='background-words'>
                    <p>
                        Adaptable
                    </p>
                    <p>
                        Adaptable
                    </p>
                    <p>
                        Adaptable
                    </p>
                    <p>
                        Adaptable
                    </p>
                </div>
                <motion.div 
                    initial={{ y: "-100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    viewport={{ once: true }}
                className='blur' />
                <motion.div 
                    initial={{ y: "-100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    viewport={{ once: true }}
                className='blur' />
                <motion.div 
                    initial={{ y: "-100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    viewport={{ once: true }}
                className='blur' />
                <motion.div 
                    initial={{ y: "-100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    viewport={{ once: true }}
                className='blur' />
                <motion.div 
                    initial={{ y: "-100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    viewport={{ once: true }}
                className='blur' />
                <motion.div 
                    initial={{ y: "-100%" }}
                    whileInView={{ y: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    viewport={{ once: true }}
                className='blur' />
            </div>
            <div className='stats'>
            <div className='widget-wrapper'>
                <div className='widget'>
                    <motion.h1
                    initial={{ y: -50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0 }}
                    viewport={{ once: true }}>
                    6
                    </motion.h1>
                    <motion.p
                    initial={{ x: -50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0 }}
                    viewport={{ once: true }}>
                    Games
                    </motion.p>
                </div>
                <div className='widget'>
                    <motion.h1
                    initial={{ y: -50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.25 }}
                    viewport={{ once: true }}>
                    15
                    </motion.h1>
                    <motion.p
                    initial={{ x: -50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.25 }}
                    viewport={{ once: true }}>
                    Projects
                    </motion.p>
                </div>
                <div className='widget'>
                    <motion.h1
                    initial={{ y: -50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.5 }}
                    viewport={{ once: true }}>
                    4
                    </motion.h1>
                    <motion.p
                    initial={{ x: -50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.5 }}
                    viewport={{ once: true }}>
                    Years of Exp.
                    </motion.p>
                </div>
                <div className='widget'>
                    <motion.h1
                    initial={{ y: -50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.75 }}
                    viewport={{ once: true }}>
                    2%
                    </motion.h1>
                    <motion.p
                    initial={{ x: -50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeInOut", delay: 0.75 }}
                    viewport={{ once: true }}>
                    Top Leetcode
                    </motion.p>
                </div>
                </div>

                <a className="resume-link-a" href={`${process.env.PUBLIC_URL}/resume.pdf`} target='_blank'>
                    <motion.div 
                    initial={{ x: "100%", opacity: 0}}
                    whileInView={{ x: 0, opacity: 1 }}
                    whileHover={{ color: "white" }}
                    transition={{
                      x: { duration: 1, ease: "easeInOut" },
                      opacity: { duration: 1, ease: "easeInOut" },
                      fontSize: { duration: 0.5, ease: "easeInOut" },
                      color: { duration: 0.5, ease: "easeInOut" }
                    }}
                    viewport={{ once: true }}
                    className='resume-link'>
                            learn more
                        <div className='skill-underline'></div>
                    </motion.div>
                </a>
            </div>
            <div className='section-projects'>
                <motion.div
                initial={{ y: 50, opacity: 0, marginBottom: "20vh", color: "#A6A6A6" }}
                whileInView={{ y: 0, opacity: 1 }}
                animate={isHovered
                    ? { color: "#5E5C5C" }
                    : { color: "#A6A6A6" }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="section-title">
                    Have a sneak look on<br></br>some projects
                </motion.div>
                <Carousel onHoverChange={handleHoverChange} />
            </div>
        </div>
    );
}

export default Page2Mobile;